module.exports = __webpack_public_path__ + "img/cark.8d9c7ce8.webp";